import React, { useEffect, useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import NotEnoughDataModal from '../../Modals/NotEnoughDataModal/NotEnoughDataModal';
import { getUnfilledCompulsoryFields } from '../../Modals/SubmitCompletedModal/CheckCompletedForm';
import { formatCSVData, retrieveData } from '../../csv/JSONtoCSV';
import { SaveCSV } from '../../csv/SaveCSVForLater';
import Papa from "papaparse";

/* 
  Generates the timestamp, saves the modified data in the CSV 
  and routes to the report page
*/

export default function GenerateReport({setUnfilledFields}) {
  const [openModal, setOpenModal] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();
  const initialFileName = localStorage.getItem("initialFileName");
  const fileName = localStorage.getItem("selectedSnapshot");
  const getS3 = useOutletContext().getS3;
  const [S3, setS3] = useState(null);

  useEffect(() => {
    getS3().then(setS3);
  }, [])

  const handleNavigate = async() => {
    // Check if compulsory fields are filled
    const unfilledFields = getUnfilledCompulsoryFields();
    if (unfilledFields.length > 0) {
      setUnfilledFields(unfilledFields);
      // Set isError to true
      setIsError(true);
      // Open the not enough data modal
      setOpenModal(true);
    } else {
      try {
        
      // Save the CSV with any changes done in the Input Form
      const csvData = await retrieveData();
      console.log("csvData: ", csvData);
      const formattedCSVData = formatCSVData(csvData);
      const csvString = Papa.unparse(formattedCSVData);
      await SaveCSV(S3, initialFileName, fileName, csvString, true);

      //Set up a Timestamp for the Report
      const date = new Date();
      const formattedDateTime = date.toLocaleString();
      localStorage.setItem('timestamp', formattedDateTime);

      // Navigate to reports page
      navigate('/reports');
    } catch (error) {
        console.error("Report couldn't be generated. Please try again.")
    }
    }
  };

  const handleCloseModal = () => {
    setIsError(false);
    setIsSuccess(false);
  };

  return (
    <>
      <button className="orange-button" style={{width: 142}} onClick={() => handleNavigate()}>
        Generate Report
      </button>
      {/* Render the not enough data modal if isError is true */}
      {isError && <NotEnoughDataModal isOpen={openModal} onClose={handleCloseModal} />}
    </>
  );
}
